import type { ComponentProps } from "react";
import type { Icon } from "../Icon";

export type ChatAction = {
  icon: ComponentProps<typeof Icon>["name"];
  label: string;
  onClick: () => void;
};

type ChatActionsInput = {
  onRename?: (() => void) | undefined;
  onFork?: (() => void) | undefined;
  onDownload?: (() => void) | undefined;
  onDelete?: (() => void) | undefined;
  onTogglePin?: (() => void) | undefined;
  pinned?: boolean;
};

export function chatActionGroups({
  onRename,
  onFork,
  onDownload,
  onDelete,
  onTogglePin,
  pinned,
}: ChatActionsInput): { primary: ChatAction[]; secondary: ChatAction[] } {
  const primary: ChatAction[] = [];
  if (onRename) {
    primary.push({ icon: "pencil", label: "Rename chat", onClick: onRename });
  }
  if (onTogglePin) {
    primary.push({
      icon: pinned ? "pin-filled" : "pin",
      label: pinned ? "Unpin chat" : "Pin chat",
      onClick: onTogglePin,
    });
  }
  if (onFork) {
    primary.push({ icon: "copy", label: "Duplicate chat", onClick: onFork });
  }
  if (onDownload) {
    primary.push({
      icon: "circle-arrow-down",
      label: "Download chat",
      onClick: onDownload,
    });
  }
  const secondary: ChatAction[] = [];
  if (onDelete) {
    secondary.push({ icon: "trash", label: "Delete chat", onClick: onDelete });
  }
  return { primary, secondary };
}
